export const getUnitInstanceLabel = (index: number, label?: string): string =>
    label && !/^Экземпляр\s+\d+$/.test(label) ? `Экз. ${index + 1} ${label}` : `Экземпляр ${index + 1}`;
